import { Routes } from '@angular/router';
import { AuthenticatedGuard, UnauthenticatedGuard } from './shared/guards/authenticated.guard';
import { PagenotfoundComponent } from './shared/components/pagenotfound/pagenotfound.component';
var ɵ0 = function () { return import("./profiles/profiles.module.ngfactory").then(function (m) { return m.ProfilesModuleNgFactory; }); }, ɵ1 = function () { return import("./admin/admin.module.ngfactory").then(function (m) { return m.AdminModuleNgFactory; }); };
var routes = [
    { path: 'profiles', loadChildren: ɵ0, canActivate: [UnauthenticatedGuard] },
    { path: 'admin', loadChildren: ɵ1, canActivate: [AuthenticatedGuard] },
    { path: 'pagenotfound', component: PagenotfoundComponent },
    { path: '', redirectTo: 'profiles', pathMatch: 'full' },
    //Wild Card Route for 404 request
    { path: '**', pathMatch: 'full', component: PagenotfoundComponent },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1 };
